import { createSelector } from 'reselect'
import { ApplicationState } from 'store/types/common'

const getState = (state: ApplicationState) => state.playerBattlesAndLoyaltyPoints

export const makeGetPlayerBattlesAndLoyaltyPoints = createSelector(getState, state => state.PlayerBattlesAndLoyaltyPoints)